<template>
  <v-dialog v-model="visible" max-width="445" persistent>
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          color="gray-6"
          flat
          fab
          @click.native="cancel"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-5">
        {{ $t(`${namespace}.text`) }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="cancel"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="accent"
          depressed
          round
          @click.prevent="close"
        >
          {{ $t('Common.proceed') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Components.Incentives.dialogs.edit'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>
